import React, { useMemo } from 'react';
import { Section, SkeletonItem } from '@atlaskit/side-navigation';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { getSystemNavigationPaths } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/get-navigation-path/system/index.tsx';
import { matchUrlPathname } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { useFeatures } from '../../../controllers/features/index.tsx';
import messages from './messages.tsx';

/**
 *  Returns Menu navigation respecting the current user permissions
 *  When updating this file, make sure to also update the following files if necessary:
 * - src/packages/navigation-apps/sidebar/common/src/controllers/use-navigation-path/system
 */
export const AdvancedSection = (): React.JSX.Element => {
	const { data: features } = useFeatures();
	const { formatMessage } = useIntl();

	const navigationPath = useMemo(() => getSystemNavigationPaths(), []);

	if (features == null) return <SkeletonItem />;

	return (
		<Section title={formatMessage(messages.advanced)}>
			{features.hasAttachments && (
				<MenuItem
					analytics={{ itemId: 'attachments' }}
					href={navigationPath.advancedSectionAttachments}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.attachments)}
				</MenuItem>
			)}
			{features.hasEvents && (
				<MenuItem
					analytics={{ itemId: 'events' }}
					href={navigationPath.advancedSectionEvents}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.events)}
				</MenuItem>
			)}
			{features.hasWebHooks && (
				<MenuItem
					analytics={{ itemId: 'webhooks' }}
					href={navigationPath.advancedSectionWebHooks}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.webhooks)}
				</MenuItem>
			)}
			{features.hasLexoRankManagement && (
				<MenuItem
					analytics={{ itemId: 'lexorank-management' }}
					href={navigationPath.advancedLexoRankManagement}
					selectedOn={matchUrlPathname()}
				>
					{formatMessage(messages.lexorankManagement)}
				</MenuItem>
			)}
		</Section>
	);
};
